<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="scmInfoUserContactsCode"
    >
      <template v-slot:company="{ row }">
        <div>
          <el-link
            :underline="false"
            type="primary"
            @click="viewScmDetail(row.scmCode)"
          >
            {{ row.companyName }}
          </el-link>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.contactStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.contactStatusName }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <b-button variant="light">
              <i class="el-icon-more"></i>
            </b-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="'view:' + row.scmInfoUserContactsCode"
              >
                {{ $l('table_contact_btn_view') || '查看名片' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-delete"
                divided
                :command="'del:' + row.scmInfoUserContactsCode"
              >
                {{ $l('table_contact_btn_del') || '删除名片' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center" class="mt-5">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      ref="editContactDialog"
      @opened="dialogOpened"
      :title="editContactDialogTitle"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="contactCancel"
      :close-on-click-modal="false"
      width="1000px"
    >
      <edit-contact
        ref="contactsDetail"
        @success="contactSuccess"
        @addNewCancel="contactCancel"
      ></edit-contact>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    EditContact: () => import('../contact/edit'),
  },
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      editContactDialogTitle: '',
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          fixed: 'left',
          headerAlign: 'center',
          align: 'center',
          type: 'seq',
        },

        {
          field: 'contactName',
          headerAlign: 'left',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_contact_label_name') || '联系人',
          showHeaderOverflow: 'title',
        },
        {
          field: 'contactJob',
          headerAlign: 'left',
          align: 'left',
          minWidth: 120,
          title: this.$l('contact_label_contactJob') || '职务',
          showHeaderOverflow: 'title',
        },
        {
          field: 'contactMobile',
          headerAlign: 'left',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_contact_contact_mobile') || '联系人手机',
          showHeaderOverflow: 'title',
        },

        {
          field: 'contactPhone',
          headerAlign: 'left',
          align: 'left',
          minWidth: 250,
          title: this.$l('contact_label_contactPhone') || '固定电话',
          showHeaderOverflow: 'title',
        },
        {
          field: 'company',
          headerAlign: 'left',
          align: 'left',
          minWidth: 280,
          title: this.$l('table_contact_label_company') || '公司',
          showHeaderOverflow: 'title',
          slots: {
            default: 'company',
          },
        },
        {
          field: 'companyAddress',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('contact_label_companyAddress') || '公司地址',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
      ],
      formData: {},
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 175
    },
    viewScmDetail(val) {
      if (val === null) {
        this.$message.warning('该名片尚未关联供应商档案')
        return
      }
      this.$router.push({
        name: 'resourceManagement-scmInfoDetail',
        params: {
          scmCode: val,
        },
      })
    },
    handleCommand(command) {
      let type = (command || '').split(':')[0]
      let code = (command || '').split(':')[1]
      if (type === 'view') {
        this.editContact(type, code)
      } else if (type === 'del') {
        this.delContact(code)
      }
    },
    editContact(type, val) {
      this.formData = {
        type: type,
        scmInfoUserContactsCode: val,
        contactNameCardUrl1: '',
      }
      this.formOption.dialogFormVisible = true
      if (type === 'view') {
        this.editContactDialogTitle =
          this.$l('table_contact_btn_view') || '查看名片'
      }
    },
    delContact(code) {
      let param = {
        scmInfoUserContactsCode: code,
      }
      this.$confirm(this.$l('INDEX.tips_question_delete') || '是否删除？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.scmInfoUserContactsDelApi(param).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功',
              type: 'success',
            })
            this.$emit('reload')
          })
        })
        .catch(() => {})
    },
    dialogOpened() {
      this.$refs.contactsDetail.init(this.formData)
    },
    contactSuccess() {
      this.formOption.dialogFormVisible = false
      this.$emit('reload')
    },
    reload() {
      this.$emit('reload')
    },
    contactCancel() {
      this.formOption.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}

// font-size: 14px; color: #606266
</style>
